import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusSquareOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import ListCard, { CardAction, initialsOf } from "../CardList/ListCard";
import { formatPhoneNumber } from "../../utils/phoneFormat";

// Same format as the table's Account Created and Last Login columns.
const dateTime = (epoch) => {
  const date = new Date(parseInt(epoch, 10));
  return Number.isNaN(date.getTime())
    ? null
    : date.toLocaleDateString("en-US", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
};

/**
 * One user on a phone (the Users table's 11 columns don't fit): who they are
 * and their status up top, how to reach them in the middle, account state and
 * the row's actions at the bottom — every column of the table, no more.
 */
const UserCard = ({
  user,
  accessType,
  statusToggle,
  onEdit,
  onResetPassword,
  onDelete,
  onReactivate,
}) => {
  const { fullName, email, phone, role, defaultOffice, isActive } = user;
  const lastLogin = dateTime(user.lastLogin);
  const createdAt = dateTime(user.createdAt);

  return (
    <ListCard
      title={fullName}
      initials={initialsOf(
        user.firstName || user.lastName
          ? `${user.firstName ?? ""} ${user.lastName ?? ""}`
          : fullName
      )}
      muted={!isActive}
      subtitle={
        <>
          <b className="font-semibold text-gray-700">{role?.name?.toUpperCase()}</b>
          {" · "}
          <span className="capitalize">{accessType.toLowerCase()}</span>
          {" · "}
          {defaultOffice?.name ?? "No office"}
        </>
      }
      status={statusToggle}
      meta={
        <>
          {user.deletedAt ? (
            <b className="text-red">Deleted</b>
          ) : user.isPasswordReseted ? (
            <b className="text-green">
              <CheckOutlined aria-hidden="true" /> Activated
            </b>
          ) : (
            <b className="text-red">
              <CloseOutlined aria-hidden="true" /> Not activated
            </b>
          )}
          <span>{lastLogin ? `Last login ${lastLogin}` : "Never logged in"}</span>
          <span>Created {createdAt ?? "--"}</span>
        </>
      }
      actions={
        user.deletedAt ? (
          <CardAction
            label={`Reactivate ${fullName}`}
            className="border-primary text-primary"
            icon={<PlusSquareOutlined />}
            onClick={onReactivate}
          />
        ) : (
          <>
            <CardAction
              label={`Edit ${fullName}`}
              className="border-primary text-primary"
              icon={<EditOutlined />}
              onClick={onEdit}
            />
            <CardAction
              label={`Reset password for ${fullName}`}
              className="border-secondary text-secondary"
              icon={<ReloadOutlined />}
              onClick={onResetPassword}
            />
            <CardAction
              label={`Delete ${fullName}`}
              danger
              icon={<DeleteOutlined />}
              onClick={onDelete}
            />
          </>
        )
      }
    >
      <span className="break-all">{email}</span>
      <span>{formatPhoneNumber(phone)}</span>
    </ListCard>
  );
};

export default UserCard;
